import { UserRoleTitles } from './constants';
import { UserRole } from './types';

export const getRoleTitle = (role: UserRole) => UserRoleTitles[role];

export const isAttorney = (role: UserRole | string) => role === 'ATTORNEY';

export const isFirmAdmin = (role: UserRole | string) => role === 'FIRM_ADMIN';

export const isSuperAdmin = (role: UserRole | string) => role === 'SUPER_ADMIN';

export const isAdmin = (role: UserRole | string) =>
  isFirmAdmin(role) || isSuperAdmin(role);
